import styled from "styled-components";

const Footer = () => {
  const today = new Date();
  return (
    <StyledFooter>
      <span>&copy; </span>
      <span>2023 - {today.getFullYear()} </span>
      <a href={process.env.REACT_APP_WEBSITE_HOST}>SpendSights</a>
      <span> by </span>
      <a href="https://kethnah.com" target="_blank" rel="noreferrer">
        Kethnah Tech Labs
      </a>
      .<span> </span>
      <span>All rights reserved.</span>
    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  text-align: center;
  font-size: 13px;
  line-height: 18px;
  padding: 24px 16px;
  span {
    color: #999;
  }
  a {
    color: #666;
    &:hover {
      color: #007aff;
    }
  }
  @media (max-width: 480px) {
    padding-bottom: 72px;
  }
`;

export default Footer;
